import { mapCmCode, prependEmptyOption } from 'helpers/Utility';
import {
  setCityOptions,
  setSubDistrictOptions,
  setVillageOptions
} from 'store/actions';
import {
  setCityKtpOptions,
  setFieldOfSubBusinessOptions,
  setSubDistrictKtpOptions,
  setVillageKtpOptions
} from 'store/actions/loanApply';

/**
 * to handle dynamic path options based on the code and data passed
 * @param {*} dispatch
 * @param {*} code
 * @param {*} data
 */
export const handleDynamicPathOptions = (dispatch, code, data) => {
  const optionMap = {
    kota: () => dispatch(setCityOptions(prependEmptyOption(mapCmCode(data)))),
    cityOfWork: () =>
      dispatch(setCityOptions(prependEmptyOption(mapCmCode(data)))),
    kecamatan: () =>
      dispatch(setSubDistrictOptions(prependEmptyOption(mapCmCode(data)))),
    districtOfWork: () =>
      dispatch(setSubDistrictOptions(prependEmptyOption(mapCmCode(data)))),
    desa: () =>
      dispatch(
        setVillageOptions(
          [{ value: '', label: '', postalCode: '' }].concat(
            data.map(d => ({
              value: d.cmCode,
              label: d.codeDescription,
              postalCode: d.postalCode
            }))
          )
        )
      ),
    wardOfWork: () =>
      dispatch(
        setVillageOptions(
          [{ value: '', label: '', postalCode: '' }].concat(
            data.map(d => ({
              value: d.cmCode,
              label: d.codeDescription,
              postalCode: d.postalCode
            }))
          )
        )
      ),
    kotaKtp: () =>
      dispatch(setCityKtpOptions(prependEmptyOption(mapCmCode(data)))),
    kecamatanKtp: () =>
      dispatch(setSubDistrictKtpOptions(prependEmptyOption(mapCmCode(data)))),
    desaKtp: () =>
      dispatch(
        setVillageKtpOptions(
          [{ value: '', label: '', postalCode: '' }].concat(
            data.map(d => ({
              value: d.cmCode,
              label: d.codeDescription,
              postalCode: d.postalCode
            }))
          )
        )
      ),
    '/SUBBDSH': () =>
      dispatch(
        setFieldOfSubBusinessOptions(
          [{ codeType: '', value: '', label: '' }].concat(
            data.map(d => ({
              codeType: d.codeType,
              value: d.cmCode,
              label: d.codeDescription
            }))
          )
        )
      )
  };

  optionMap[code]?.();
};
